import { STORY_SCENE_IDS } from "../../src/game/story";
import { NO_CONSUMABLES } from "../../src/game/Consumable";
import { GameState } from "../../src/game/GameState";
import { ALL_ARTICLE_IDS } from "../../src/game/manual";
import { STARTER_SKILLS } from "../../src/game/Skill";

/** A miter saw delivery waiting crated at the entrance, carrying unlocked. */
export const miterSawCrateShop: GameState = {
  minute: 0,
  day: 1,
  dayStartMinute: 0,
  money: 50,
  reputation: 2,
  consumables: NO_CONSUMABLES,
  clamps: 0,
  materialPiles: [],
  player: {
    name: "Player",
    position: [0, 0],
    direction: 0,
    inventory: [],
    away: null,
  },
  machines: [
    {
      machineTypeId: "workspace",
      position: [1, 2],
      rotation: 0,
      inputMaterials: [],
      processingMaterials: [],
      outputMaterials: [],
      tools: [],
      selectedOperationId: "rip",
      selectedParameters: { width: 8 },
      operationProgress: {
        status: "notStarted",
        phaseIndex: 0,
        minutesRemaining: 0,
      },
    },
  ],
  truck: { bed: [], crates: [] },
  machineCrates: [
    {
      machine: {
        machineTypeId: "miterSaw",
        position: [0, 0],
        rotation: 0,
        inputMaterials: [],
        processingMaterials: [],
        outputMaterials: [],
        tools: [],
        storedMaterials: [],
        upgrades: [],
        selectedOperationId: "cutBoard",
        operationProgress: {
          status: "notStarted",
          phaseIndex: 0,
          minutesRemaining: 0,
        },
      },
      position: [6, 8],
    },
  ],
  storage: {
    upgrades: [],
  },
  shopInfo: {
    name: "One Car Garage",
    electricity: 120,
    size: [12, 16],
    materialDropoffPosition: [10, 13],
    entrancePosition: [6, 15],
  },
  progression: {
    tutorials: {
      opening: { step: 0, dismissed: true },
      firstNight: { step: 1, dismissed: false },
      dust: { step: 0, dismissed: false },
    },
    storeUnlocked: true,
    standUnlocked: true,
    // A staged shop is past the opening: every scene has played
    story: { scenesPlayed: [...STORY_SCENE_IDS] },
    lumberyardUnlocked: false,
    salesCompleted: 1,
    sweepingUnlocked: false,
    unlockedArticles: ALL_ARTICLE_IDS,
    readArticles: ALL_ARTICLE_IDS,
    xp: 0,
    skillPoints: 0,
    unlockedSkills: STARTER_SKILLS,
  },
  stand: [],
  standSetUp: true,
  customers: [],
  dust: {},
  shopVac: null,
  broomOwned: true,
  broomPosition: [0, 0],
  dustpan: {},
};
